export const LOGIN_URL = '/login'
export const RESET_PASSWORD_URL = '/reset'
export const SET_PASSWORD_URL = '/set-password'
export const HOME_URL = '/'
export const JOBS_URL = '/jobs'
export const JOB_SCHEDULES_URL = '/job-schedules'
export const TEMPLATES_URL = '/forms'
export const VEHICLES_URL = '/vehicles'
export const MACHINE_URL = '/machines'
export const EQUIPMENTS_URL = '/equipments'
export const WORK_ORDERS_URL = '/orders'
export const MILL_ORDERS_URL = '/mill-orders'
export const ORDER_SCHEDULES_URL = '/order-schedules'
export const MAINTENANCE_URL = '/maintenance'
export const SERVICES_URL = '/services'
export const SERVICE_PROGRAMMES_URL = '/service-schedules'
export const SERVICE_TASKS_URL = '/maintenance-types'
export const INSPECTIONS_URL = '/inspections'
export const INSPECTION_SCHEDULES_URL = '/inspection-schedules'
export const ISSUES_URL = '/issues'
export const VENDORS_URL = '/vendors'
export const EMPLOYEES_URL = '/users'
export const ACCOUNT_URL = '/account'
export const CONFIG_URL = '/config'
export const ACCOUNT_HTTP = '/account/http'
export const ORDERS_URL = '/orders'
export const CHECKLIST_URL = `/checklist`
export const REVOKE_URL = 'revoke'
export const JOB_ADD_URL = `${JOBS_URL}/add`
export const JOB_EDIT_URL = `${JOBS_URL}/:id/edit`
export const JOB_SCHEDULES_ADD_URL = `${JOB_SCHEDULES_URL}/add`
export const JOB_SCHEDULES_EDIT_URL = `${JOB_SCHEDULES_URL}/:id/edit`
export const JOB_DETAILS_URL = `${JOBS_URL}/:id`
export const JOB_ADD_CONFIG_URL = `${JOB_ADD_URL}/config`
export const JOB_CHECKLIST_URL = `${JOBS_URL}/:id/checklist`
export const TEMPLATE_ADD_URL = `${TEMPLATES_URL}/add`
export const TEMPLATE_EDIT_URL = `${TEMPLATES_URL}/:id/edit`
export const VEHICLE_ADD_URL = `${VEHICLES_URL}/add`
export const VEHICLE_EDIT_URL = `${VEHICLES_URL}/:id/edit`
export const VEHICLE_DETAILS_URL = `${VEHICLES_URL}/:id`
export const MACHINE_ADD_URL = `${MACHINE_URL}/add`
export const MACHINE_EDIT_URL = `${MACHINE_URL}/:id/edit`
export const MACHINE_DETAILS_URL = `${MACHINE_URL}/:id`
export const WORK_ORDER_ADD_URL = `${WORK_ORDERS_URL}/add`
export const MILL_ORDER_DETAILS_URL = `${MILL_ORDERS_URL}/:id`
export const WORK_ORDER_EDIT_URL = `${WORK_ORDERS_URL}/:id/edit`
export const ORDER_DETAILS_URL = `${WORK_ORDERS_URL}/:id`
export const ORDER_SCHEDULE_ADD_URL = `${ORDER_SCHEDULES_URL}/add`
export const ORDER_SCHEDULE_EDIT_URL = `${ORDER_SCHEDULES_URL}/:id/edit`
export const SERVICE_ADD_URL = `${SERVICES_URL}/add`
export const SERVICE_EDIT_URL = `${SERVICES_URL}/:id/edit`
export const SERVICE_DETAILS_URL = `${SERVICES_URL}/:id`
export const SERVICE_PROGRAMME_ADD_URL = `${SERVICE_PROGRAMMES_URL}/add`
export const SERVICE_PROGRAMME_EDIT_URL = `${SERVICE_PROGRAMMES_URL}/:id/edit`
export const SERVICE_TASK_ADD_URL = `${SERVICE_TASKS_URL}/add`
export const SERVICE_TASK_EDIT_URL = `${SERVICE_TASKS_URL}/:id/edit`
export const INSPECTION_ADD_URL = `${INSPECTIONS_URL}/add`
export const INSPECTION_EDIT_URL = `${INSPECTIONS_URL}/:id/edit`
export const INSPECTION_SCHEDULE_ADD_URL = `${INSPECTION_SCHEDULES_URL}/add`
export const INSPECTION_SCHEDULE_EDIT_URL = `${INSPECTION_SCHEDULES_URL}/:id/edit`
export const INSPECTION_DETAILS_URL = `${INSPECTIONS_URL}/:id`
export const ISSUE_ADD_URL = `${ISSUES_URL}/add`
export const ISSUE_EDIT_URL = `${ISSUES_URL}/:id/edit`
export const ISSUE_DETAILS_URL = `${ISSUES_URL}/:id`
export const VENDORS_ADD_URL = `${VENDORS_URL}/add`
export const VENDORS_EDIT_URL = `${VENDORS_URL}/:id/edit`
export const EMPLOYEE_ADD_URL = `${EMPLOYEES_URL}/add`
export const EMPLOYEE_EDIT_URL = `${EMPLOYEES_URL}/:id/edit`
export const EMPLOYEE_DETAILS_URL = `${EMPLOYEES_URL}/:id`
export const EQUIPMENTS_ADD_URL = `${EQUIPMENTS_URL}/add`
export const EQUIPMENTS_EDIT_URL = `${EQUIPMENTS_URL}/:id/edit`
export const EQUIPMENTS_DETAILS_URL = `${EQUIPMENTS_URL}/:id`
export const PSEUDO_JOB_URLS = [WORK_ORDERS_URL, INSPECTIONS_URL, ISSUES_URL, SERVICES_URL]

export const HOME_URL_NAME = 'Overview'
export const LOGIN_URL_NAME = 'Login'
export const RESET_PASSWORD_URL_NAME = 'Reset Password'
export const SET_PASSWORD_URL_NAME = 'Set Password'
export const JOB_DETAILS_URL_NAME = 'Job Details'
export const JOB_ADD_URL_NAME = 'Create job'
export const JOB_EDIT_URL_NAME = 'Edit job'
export const TEMPLATE_CONFIGURATION_NAME = 'Form configuration'
export const TEMPLATE_ADD_URL_NAME = 'Add form'
export const TEMPLATE_EDIT_URL_NAME = 'Edit form'
export const VEHICLE_ADD_URL_NAME = 'Add vehicle'
export const VEHICLE_EDIT_URL_NAME = 'Edit vehicle'
export const JOBS_URL_NAME = 'Jobs'
export const JOB_SCHEDULES_URL_NAME = 'Schedules'
export const JOB_SCHEDULES_ADD_URL_NAME = 'Add schedule'
export const JOB_SCHEDULES_EDIT_URL_NAME = 'Edit schedule'
export const USERS_URL_NAME = 'Users'
export const JOB_CHECKLIST_NAME = 'Job Checklist'
export const TEMPLATES_URL_NAME = 'Forms'
export const VEHICLES_URL_NAME = 'Vehicles'
export const VEHICLE_DETAILS_URL_NAME = 'Vehicle details'
export const MACHINE_URL_NAME = 'Machines'
export const MACHINE_ADD_URL_NAME = 'Add machine'
export const MACHINE_EDIT_URL_NAME = 'Edit machine'
export const MACHINE_DETAILS_URL_NAME = 'Machine details'
export const WORK_ORDERS_URL_NAME = 'Orders'
export const WORK_ORDER_ADD_URL_NAME = 'Create new purchase order'
export const WORK_ORDER_EDIT_URL_NAME = 'Edit purchase order'
export const MILL_ORDERS_URL_NAME = 'Mill orders'
export const MILL_ORDER_DETAILS_URL_NAME = 'Mill Order details'
export const ORDER_DETAILS_URL_NAME = 'Order details'
export const ORDER_SCHEDULES_URL_NAME = 'Order schedules'
export const ORDER_SCHEDULE_ADD_URL_NAME = 'Create purchase order schedule'
export const ORDER_SCHEDULE_EDIT_URL_NAME = 'Edit purchase order schedule'
export const SERVICE_ADD_URL_NAME = 'Add new service'
export const SERVICE_EDIT_URL_NAME = 'Edit service'
export const SERVICE_DETAILS_URL_NAME = 'Service details'
export const SERVICE_PROGRAMME_ADD_URL_NAME = 'Add new service schedule'
export const SERVICE_PROGRAMME_EDIT_URL_NAME = 'Edit service schedule'
export const SERVICE_TASK_ADD_URL_NAME = 'Add new service task'
export const SERVICE_TASK_EDIT_URL_NAME = 'Edit service task'
export const INSPECTION_ADD_URL_NAME = 'Create new inspection'
export const INSPECTION_EDIT_URL_NAME = 'Edit inspection'
export const INSPECTION_SCHEDULE_ADD_URL_NAME = 'Add inspection schedule'
export const INSPECTION_SCHEDULE_EDIT_URL_NAME = 'Edit inspection schedule'
export const INSPECTION_DETAILS_URL_NAME = 'Inspection details'
export const ISSUE_ADD_URL_NAME = 'Create new issue'
export const ISSUE_EDIT_URL_NAME = 'Edit issue'
export const ISSUE_DETAILS_URL_NAME = 'Issue details'
export const SERVICES_URL_NAME = 'Services'
export const SERVICE_PROGRAMMES_URL_NAME = 'Service schedules'
export const SERVICE_TASKS_URL_NAME = 'Service tasks'
export const EQUIPMENTS_URL_NAME = 'Equipments'
export const EQUIPMENTS_ADD_URL_NAME = 'Add equipment'
export const EQUIPMENTS_EDIT_URL_NAME = 'Edit equipment'
export const EQUIPMENTS_DETAILS_URL_NAME = 'Equipment details'
export const MAINTENANCE_URL_NAME = 'Maintenance'
export const INSPECTIONS_URL_NAME = 'Inspections'
export const INSPECTION_SCHEDULES_URL_NAME = 'Inspection Schedules'
export const ISSUES_URL_NAME = 'Issues'
export const ORDERS_URL_NAME = 'Orders'
export const VENDORS_URL_NAME = 'Vendors'
export const VENDORS_ADD_URL_NAME = 'Add new vendor'
export const VENDORS_EDIT_URL_NAME = 'Edit vendor'
export const EMPLOYEE_ADD_URL_NAME = 'Add new employee'
export const EMPLOYEE_EDIT_URL_NAME = 'Edit employee'
export const EMPLOYEES_URL_NAME = 'Employees'
